function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Caminho_129",
  "data-name": "Caminho 129",
  d: "M206.58,240.235a19.448,19.448,0,1,0,19.448,19.448,19.448,19.448,0,0,0-19.448-19.448M208,270.5a10.909,10.909,0,1,1,9.4-9.4,10.914,10.914,0,0,1-9.4,9.4",
  transform: "translate(-187.132 -240.234)",
  fill: "#348C30"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Caminho_130",
  "data-name": "Caminho 130",
  d: "M352.5,240.234v19.43a10.906,10.906,0,1,1-21.811,0V245.131l-8.54-4.9v19.43A19.448,19.448,0,0,0,352.5,275.77v3.344a10.91,10.91,0,0,1-10.911,10.9H327.216l4.9,8.543h9.474a19.45,19.45,0,0,0,19.451-19.447V245.131Z",
  transform: "translate(-231.064 -240.234)",
  fill: "#348C30"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "Caminho_131",
  "data-name": "Caminho 131",
  d: "M266.245,259.675l-11.96,8.825v10.615l19.154-14.132,19.155,14.132V268.5l-11.961-8.825,11.961-8.825V240.235l-19.155,14.132-19.154-14.132V250.85Z",
  transform: "translate(-208.982 -240.234)",
  fill: "#348C30"
});

var SvgOxyLogo = function SvgOxyLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "OXY_-_LOGO",
    "data-name": "OXY - LOGO",
    width: 129.977,
    height: 58.328,
    viewBox: "0 0 129.977 58.328",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOxyLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oxy-logo.0ade4824.svg";
export { ForwardRef as ReactComponent };